/** Integer with thousands separators. Presentation only; data stays numeric. */
export function formatInt(n: number): string {
  return Math.round(n).toLocaleString('en-US');
}

/** "48,200 USD". Money is integer USD per month unless stated otherwise. */
export function money(n: number): string {
  return `${formatInt(n)} USD`;
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');
}
